<template>
    <div class="discount-codes-container">
      <h1 class="content-header discount-codes-header">Discount Codes Management</h1>
      <p class="content-header-sub">
        Manage your discount codes for your shop here.
      </p>
     
  
      <div class="discount-codes-inner">
        <div class="discount-codes-top">
        <select
          name=""
          id=""
          class="choose-shop-item dropdown"
          v-model="selectedDiscountCode"
          @change="updateSelectedDiscountCode"
        >
          <option disabled value="null">Discount Code</option>
          <option
            v-for="code in discountCodes"
            :key="code.id"
            :value="code"
          >
            {{ code.code }}
          </option>
        </select>

        <button class="btn add-new-code-btn" @click="showAddModal = true">
          <p>Add New Code</p>
        </button>
      
        </div>
        <div class="discount-codes-body" v-if="selectedDiscountCode">
        <p class="discount-codes-body-heading content-header-sub">Discount Code Settings</p>

        <div class="discount-codes-body-settings">
          <div class="setting-input">
            <label for="discount-code" class="label">Code</label>
            <input
              type="text"
              class="input"
              v-model="selectedDiscountCodeUpdated.code"
              readonly
            />
          </div>
          <div class="setting-input">
            <label for="discount" class="label">Discount %</label>
            <input
              type="text"
              class="input"
              v-model="selectedDiscountCodeUpdated.discount"
            />
          </div>
          
          <div class="setting-input">
            <label for="shop-item-name" class="label">Uses</label>
            <input
              type="text"
              class="input"
              v-model="selectedDiscountCodeUpdated.uses"
              
            />
          </div>
  
          <div class="setting-input">
            <label for="expiry" class="label"
              >Expiry (Local)</label>
            <input
              name=""
              class="input"
              v-model="formattedTimeEdit"
              type="datetime-local"
              :min="currentDateTimeLocal"
            />
          </div>

          <div class="setting-input">
            <label for="enabled" class="label">Enabled</label>
            <select
              name=""
              id=""
              class="dropdown"
              v-model="selectedDiscountCodeUpdated.enabled"
            >
              <option :value="false">False</option>
              <option :value="true">True</option>
            </select>
          </div>

        

         
        
          <div class="setting-input">
            <button @click="showEditModal = true">
              Restricted Roles
            </button>
          </div> 
        </div>

        <div class="smi-body-footer">
          <button
            class="modal-btn delete-btn cancel-btn"
            @click="deleteDiscountCode"
          >
            Delete Item
          </button>
          <button class="modal-btn save-settings-btn" @click="updateDiscountCode" :disabled="!allowSaveChanges">
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="btn-text">Save Changes</p>
          </button>
        </div>
      </div>
      </div>
  
      <Modal :show="showEditModal" @update:show="showEditModal = $event">
        <template v-slot:header-content>
        <div class="modal-header-content-container">
          <p class="modal-sub-heading">Restricted Roles</p>
          <p class="modal-main-heading">Edit Roles</p>
          <div class="modal-heading-discord-id-validator">
            <input
              type="text"
              placeholder="Enter Role ID/Name"
              class="modal-option-input search-input"
              v-model="roleFilter"
            />
          </div>
        </div>
         
        </template>
        <template v-slot:body-content>
            <div class="modal-body-content-container">
          <div class="modal-body-container">
            <div
              v-for="role in Roles"
              :key="role.id"
              class="modal-checkbox-select"
              :class="{
                'active-checked': this.selectedDiscountCodeUpdated.restricted_roles.includes(
                  role.id
                )
              }"
              @click="updateRestrictedRoles($event, role.id)"
            >
              <input
                type="checkbox"
                :id="role.id"
                class="checkbox"
                :checked="selectedDiscountCodeUpdated.restricted_roles.includes(
                  role.id
                )"
                @click.prevent
              />
              <label :for="role.id" class="checkbox-label"></label>

              <p class="checkbox-name">{{ role.name }}</p>
            </div>
          </div>
        </div>
        
        </template>
        <template v-slot:footer-content>
            
         
        </template>
      </Modal>

      <Modal :show="showAddModal" @update:show="showAddModal = $event">
        <template v-slot:header-content>
        <div class="modal-header-content-container">
          <p class="modal-sub-heading">Discount Codes</p>
          <p class="modal-main-heading">Add New Code</p>
        </div>
         
        </template>
        <template v-slot:body-content>
            <div class="modal-body-content-container">
          <div class="modal-row">
            <div class="modal-input">
              <label for="discount-code" class="label required-input"
                >Code</label
              >
              <input
                type="text"
                id="discount-code"
                class="input"
                v-model="newDiscountCode.code"
              />
            </div>
            <div class="modal-input">
              <label for="discount-value" class="label required-input"
                >Discount %</label
              >
              <input
                type="text"
                id="discount-value"
                class="input"
                v-model="newDiscountCode.discount"
                :min="1"
              />
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label for="discount-uses" class="label"
                >Uses</label
              >
              <input
                type="number"
                id="discount-uses"
                class="input"
                min="1"
                max="1000000"
                v-model="newDiscountCode.uses"
              />
            </div>
            <div class="modal-input">
            <label for="code_expiry" class="label">Expiry (Local)</label>
              <input
                name=""
                class="input"
                v-model="formattedTimeAdd"
                type="datetime-local"
                :min="currentDateTimeLocal"
              />
              
            </div>
          </div>

          <div class="modal-row">
            <div class="modal-input">
              <label for="code-enabled" class="label">Enabled</label>
              <select
                name=""
                id=""
                class="dropdown"
                v-model="newDiscountCode.enabled"
              >
                <option :value="false">False</option>
                <option :value="true">True</option>
              </select>
            </div>
          </div>
          
        </div>
        
        </template>
        <template v-slot:footer-content>
            <div class="modal-footer-content-container">
          <button class="modal-btn cancel-btn" @click="discardNewDiscountCode">
            Cancel
          </button>
          <button
            class="modal-btn save-btn"
            @click="addNewDiscountCode"
            :disabled="
              !newDiscountCode.code ||
              !newDiscountCode.discount ||
              !allowDiscountCodeAdd
            "
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.83325 8.66675L6.49992 11.3334L13.1666 4.66675"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p class="btn-text">Add New Code</p>
          </button>
        </div>
         
        </template>
      </Modal>
  
    
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import Modal from './Modal.vue';
  import { validatePagePermissions } from '../utils/permissions';
  
  export default {
    name: 'DiscountsManagement',
    components: {
      Modal,
    },
    data() {
      return {

        discountCodes: [],
        selectedDiscountCode: null,
        selectedDiscountCodeUpdated: {},
        showEditModal: false,
        allowSaveChanges: true,
        currentDateTimeLocal: new Date().toISOString().slice(0, 16),
        newDiscountCode: {
          code: '',
          discount: 1,
          enabled: false,
        },
        allowDiscountCodeAdd: true,
        roleFilter: '',
        showAddModal: false,

        
      };
    },
  
    computed: {

        formattedTimeAdd: {
        get() {
            if (this.newDiscountCode.expires_at) {
                let local_time = new Date(this.newDiscountCode.expires_at);
            } else {
                return;
            }
            
          let local_time = new Date();
    
          let local_date_string = `${local_time.getFullYear()}-${String(local_time.getMonth() + 1).padStart(2, '0')}-${String(local_time.getDate()).padStart(2, '0')}T${String(local_time.getHours()).padStart(2, '0')}:${String(local_time.getMinutes()).padStart(2, '0')}`;
        
          return local_date_string;
        },
        set(value) {
          // Convert local time back to UTC
          const localDate = new Date(value);
          this.newDiscountCode.expires_at = localDate.toISOString();
        },
      },

      formattedTimeEdit: {
  get() {
    if (!this.selectedDiscountCodeUpdated.expires_at) {
     
      return "";
    }

    const hasZ = this.selectedDiscountCodeUpdated.expires_at.includes("Z");
    const hasOffset = /[+-]\d{2}:\d{2}$/.test(
      this.selectedDiscountCodeUpdated.expires_at
    );

    let isoString = this.selectedDiscountCodeUpdated.expires_at.replace(
      " ",
      "T"
    );
    if (!hasZ && !hasOffset) {
      isoString += "Z";
    }

    // Create a Date object assuming it's UTC
    const local_time = new Date(isoString);

    let local_date_string = `${local_time.getFullYear()}-${String(
      local_time.getMonth() + 1
    ).padStart(2, "0")}-${String(local_time.getDate()).padStart(
      2,
      "0"
    )}T${String(local_time.getHours()).padStart(2, "0")}:${String(
      local_time.getMinutes()
    ).padStart(2, "0")}`;

    return local_date_string;
  },
  set(value) {
    if (!value) {
      // Handle the case where the input is cleared
      this.selectedDiscountCodeUpdated.expires_at = null;
    } else {
      // Convert local time back to UTC
      const localDate = new Date(value);
      this.selectedDiscountCodeUpdated.expires_at = localDate.toISOString();
    }
  },
},

    Roles() {
      if (!this.$store.state.cachedRolesChannelsUsers.roles) {
        return [];
      }

      let filtered_roles = []

      if (this.roleFilter) {
        // filter based on name OR id
        filtered_roles = this.$store.state.cachedRolesChannelsUsers.roles.filter(
          role =>
            role.name.toLowerCase().includes(this.roleFilter.toLowerCase()) ||
            role.id.toLowerCase().includes(this.roleFilter.toLowerCase())
        );
      } else {
       filtered_roles = this.$store.state.cachedRolesChannelsUsers.roles;
      }

      return this.sortRoles(filtered_roles);
    },
  
    },
  
    methods: {
        sortRoles(filtered_roles) {
            return filtered_roles.slice().sort((a, b) => {
                if (this.selectedDiscountCodeUpdated.restricted_roles.includes(a.id)) {
                return -1;
                } else if (this.selectedDiscountCodeUpdated.restricted_roles.includes(b.id)) {
                return 1;
                } else {
                return 0;
                }
            });
            },
            updateRestrictedRoles(event, roleId) {
                if (!event.target.classList.contains('modal-checkbox-select') && !event.target.classList.contains('checkbox-name')) {
                    return;
                }
            let newRoles = [...this.selectedDiscountCodeUpdated.restricted_roles];

            if (newRoles.includes(roleId)) {
                newRoles = newRoles.filter(id => id !== roleId);
            } else {
                newRoles.push(roleId);
            }

            // Instead of direct mutation, update the whole object (best practice)
            this.selectedDiscountCodeUpdated = {
                ...this.selectedDiscountCodeUpdated,
                restricted_roles: newRoles
            };
            },
        updateSelectedDiscountCode() {
            this.selectedDiscountCodeUpdated = JSON.parse(JSON.stringify(this.selectedDiscountCode));
            console.log(this.selectedDiscountCodeUpdated);
          },

        discardNewDiscountCode() {
            this.newDiscountCode = {
              code: '',
              discount: 0,
              enabled: false,
            };
            this.showModal = false;
          },

        async addNewDiscountCode() {
            this.allowDiscountCodeAdd = false;
            if (this.newDiscountCode.expires_at) {
            // Convert the ISO string to a UNIX timestamp
            this.newDiscountCode.expires_at = new Date(this.newDiscountCode.expires_at).getTime() / 1000;
            }
            const response = await this.$store.dispatch('sendRequest', {
            method: 'POST',
            url: `${this.$store.state.apiUrl}/api/discount_codes`,
            data: {
            ...this.newDiscountCode,
            uses: null ? this.newDiscountCode.uses == '' : this.newDiscountCode.uses,
            },
            show_message_on_success: true,
        });

        if (response) {
          console.log(response);
            this.allowDiscountCodeAdd = true;
            this.showAddModal = false;
            let cachedDiscountCodes = this.$store.state.cachedDiscountCodes.codes
          ? this.$store.state.cachedDiscountCodes.codes
          : [];
          cachedDiscountCodes.push(response.discount_code);

          let websocketMessage = {
          event: 'updatingCache',
          action: 'updateCachedDiscountCodes',
          discord_server_id: this.$store.state.client_discord_server_id,
          data: {
            codes: cachedDiscountCodes,
            lastCacheTimestamp: new Date()
          },
        };

        this.$store.state.websocket.send(JSON.stringify(websocketMessage));
        this.getDiscountCodes();
        } else {
            this.allowDiscountCodeAdd = true;
            return
        }

        },

        async getDiscountCodes() {
                let cached_time = this.$store.state.cachedDiscountCodes.lastCacheTimestamp;
                if (cached_time) {
                cached_time = new Date(cached_time);
                }
            
                let current_time = new Date();
                
                let time_difference = current_time - cached_time;

                
                // if less than 10 minutes, use the cached shop items
                if (time_difference < 600000) {
                return this.discountCodes = this.$store.state.cachedDiscountCodes.codes;
                }


              const response = await this.$store.dispatch('sendRequest', {
                method: 'GET',
                url: `${this.$store.state.apiUrl}/api/discount_codes`,
                show_message_on_success: false,
              });
              if (response) {
                this.discountCodes = response;
                let websocketMessage = {
                  event: 'updatingCache',
                  action: 'updateCachedDiscountCodes',
                  discord_server_id: this.$store.state.client_discord_server_id,
                  data: {
                    codes: response,
                    lastCacheTimestamp: new Date()
                  },
                };
                this.$store.state.websocket.send(JSON.stringify(websocketMessage));
              }
        },

        getChangedKeyValuePairs(changdObject, originalObject) {
            let changedValues = {};
            for (let key in changdObject) {
                if (changdObject[key] !== originalObject[key]) {
                changedValues[key] = changdObject[key];
                }
            }
            return changedValues;
        },


        async updateDiscountCode() {
        this.allowSaveChanges = false;

        let changed_values = this.getChangedKeyValuePairs(
            this.selectedDiscountCodeUpdated,
            this.selectedDiscountCode
        );

        // if expires_at is changed, we must make it a timestamp
        if (changed_values.expires_at) {
            changed_values.expires_at = new Date(changed_values.expires_at).getTime() / 1000;
        }

        if (changed_values.uses) {
            changed_values.uses = null ? changed_values.uses == '' : changed_values.uses;
        }

        const response = await this.$store.dispatch('sendRequest', {
            method: 'PUT',
            url: `${this.$store.state.apiUrl}/api/discount_codes`,
            data: {
            ...changed_values,
            id: this.selectedDiscountCodeUpdated.id,
            },
            show_message_on_success: true,
        });

        if (response) {
            this.allowSaveChanges = true;
            this.selectedDiscountCode = response.discount_code;

            let cachedDiscountCodes = this.$store.state.cachedDiscountCodes.codes
            ? this.$store.state.cachedDiscountCodes.codes
            : [];
            let index = cachedDiscountCodes.findIndex((code) => code.id === this.selectedDiscountCodeUpdated.id);
            cachedDiscountCodes[index] = response.discount_code;

            let websocketMessage = {
            event: 'updatingCache',
            action: 'updateCachedDiscountCodes',
            discord_server_id: this.$store.state.client_discord_server_id,
            data: {
                codes: cachedDiscountCodes,
                lastCacheTimestamp: new Date()
            },
            };

            this.$store.state.websocket.send(JSON.stringify(websocketMessage));

            this.getDiscountCodes();
        } else {
            this.allowSaveChanges = true;
            return;
        }
    
    },

    async deleteDiscountCode() {
        this.allowSaveChanges = false;
        const response = await this.$store.dispatch('sendRequest', {
          method: 'DELETE',
          url: `${this.$store.state.apiUrl}/api/discount_codes`,
          data: {
            id: this.selectedDiscountCode.id,
          },
          show_message_on_success: true,
        });

        if (response) {
          this.allowSaveChanges = true;
          this.selectedDiscountCode = null;

          let cachedDiscountCodes = this.$store.state.cachedDiscountCodes.codes
            ? this.$store.state.cachedDiscountCodes.codes
            : [];
          let index = cachedDiscountCodes.findIndex((code) => code.id === this.selectedDiscountCodeUpdated.id);
          cachedDiscountCodes.splice(index, 1);

          let websocketMessage = {
            event: 'updatingCache',
            action: 'updateCachedDiscountCodes',
            discord_server_id: this.$store.state.client_discord_server_id,
            data: {
              codes: cachedDiscountCodes,
              lastCacheTimestamp: new Date()
            },
          };

          this.$store.state.websocket.send(JSON.stringify(websocketMessage));

          this.getDiscountCodes();
        } else {
          this.allowSaveChanges = true;
          return;
        }
      },

    
},
  
    async mounted() {
        await this.getDiscountCodes();
      
    },
  };
  </script>
  
  <style scoped>
  .discount-codes-container {
  background: rgba(187, 218, 255, 0.04);
  border: 1px solid rgba(187, 218, 255, 0.08);
  border-radius: 16px;
  width: 100%;
  display: flex;
  padding: 24px;
  flex-direction: column;
  text-align: left;
}

.discount-codes-header {
  margin-bottom: 8px;
}

.shop-stats-container {
  /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, max-content)); */
  display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 250px));
    align-items: center;
    color: white;
    column-gap: 20px;
    row-gap: 10px;
  /* column-gap: 50px;
  row-gap: 12px; */
}

.stb-heading {
  font-size: 1.6rem;
  white-space: nowrap;
}

.shop-stat-box {
  background-color: rgba(195, 218, 252, 0.08);
  display: flex;
  height: 100%;
  justify-content: center;
  color: white;
  border-radius: 16px;
  padding: 4px 12px;
}

.shop-management-inner {
  margin-top: 24px;
}

.discount-codes-top {
  display: grid;
    grid-template-columns: repeat(auto-fit, minmax(165px, 165px));
    align-items: center;
    color: white;
    column-gap: 20px;
    row-gap: 10px;
  align-items: flex-end;
}
.add-new-code-btn {
  box-sizing: border-box;
  display: inline-block;
  line-height: 150%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  font-family: 'DM Mono';
  font-size: 1.4em;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-align: left;
  padding: 10px 12px 10px 12px;
  border-radius: 12px;
  outline: none;
  border: none;
}

.discount-codes-body-heading {
  margin-top: 36px;
}

.discount-codes-body-settings {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, max-content));
  column-gap: 20px;
  row-gap: 12px;
}

.modal-input {
  flex-direction: column;
  text-align: left;
  display: flex;
  row-gap: 4px;
  justify-content: end;
}

.input {
  background-color: rgba(195, 218, 252, 0.08);
  box-sizing: border-box;
  display: inline-block;
  padding: 8px 12px;
  border: 1px solid rgba(195, 238, 252, 0.16);
  border-radius: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  /* identical to box height, or 21px */

  color: #ffffff;
}
.input:focus,
.dropdown:focus {
  outline: none;
}

.dropdown option {
  color: black;
}

.dropdown {
  width: 100%;
}

.input option {
  color: black;
}

.label {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 15px;
  /* identical to box height */
  /* letter-spacing: 0.08em; */
  padding-left: 5px;

  color: #bbced8;
}

.setting-input button {
  background: rgba(195, 218, 252, 0.08);
  border: none;
  border-radius: 12px;
  padding: 8px 12px;
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  /* identical to box height, or 21px */
  color: #ffffff;
}

.add-shop-item-btn,
.choose-shop-item {
  height: max-content;
}

.modal-body-content-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.smi-body-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 24px;
  column-gap: 12px;
}
.save-settings-btn, .delete-btn {
  width: max-content;
}



.modal-body-container {
  margin-top: 8px;
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding-right: 8px;
}

.active-checked {
  background: rgba(195, 218, 252, 0.08);
}
.checkbox {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #bbced8a3;
  border-radius: 4px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label {
  width: 16px;
  height: 16px;
  border: 1px solid #bbced8a3;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.checkbox:checked + .checkbox-label {
  background: #42d09c3d;

  border: 2px solid #42d09ca3;
  background-image: url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.3657%204.23447C13.5157%204.3845%2013.5999%204.58794%2013.5999%204.80007C13.5999%205.0122%2013.5157%205.21565%2013.3657%205.36567L6.96568%2011.7657C6.81566%2011.9156%206.61221%2011.9999%206.40008%2011.9999C6.18795%2011.9999%205.9845%2011.9156%205.83448%2011.7657L2.63448%208.56567C2.48876%208.41479%202.40812%208.21271%202.40994%208.00295C2.41177%207.7932%202.4959%207.59255%202.64423%207.44422C2.79255%207.29589%202.9932%207.21176%203.20296%207.20993C3.41272%207.20811%203.6148%207.28875%203.76568%207.43447L6.40008%2010.0689L12.2345%204.23447C12.3845%204.0845%2012.588%204.00024%2012.8001%204.00024C13.0122%204.00024%2013.2157%204.0845%2013.3657%204.23447Z%22%20fill%3D%22%2342D09C%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: center;
}

.replacement-string-textbox textarea {
  height: 200px;
}
.replacement-string-textbox {
  width: 100%;
}
.modal-heading-discord-id-validator, .modal-heading-admin-selector {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    align-items: center
}

.modal-heading-discord-id-validator {
    gap: 16px;
}

.validate-id-btn{
    font-size: 1.2rem ;

    padding: 6px 12px;
}

.validate-id-input {
    padding: 6px 12px;
}

.setting-input {
  flex-direction: column;
  text-align: left;
  display: flex;
  row-gap: 4px;
  justify-content: end;
}
 
  </style>
  